export const PROJECT_STATUS_INACTIVE = 0;
export const PROJECT_STATUS_ACTIVE = 1;